<!--
 * @Author: DQL
 * @Date: 2020-03-19 09:41:28
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-28 15:16:01
 * @Description: 新增下级机构模态框
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="新增"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="140px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          v-if="dlParams.parentDeptCode"
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="上级组织代码"
          >
            <span class="c-form__read">
              {{ dlParams.parentDeptCode || '-' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          v-if="dlParams.parentDeptName"
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="上级组织名称"
          >
            <span class="c-form__read">
              {{ dlParams.parentDeptName || '-' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织代码"
            prop="deptCode"
          >
            <el-input
              v-model.trim="fd.deptCode"
              class="c-form__input"
              placeholder="组织代码"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织名称"
            prop="deptName"
          >
            <el-input
              v-model.trim="fd.deptName"
              class="c-form__input"
              placeholder="组织名称"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织简称"
            prop="deptShortName"
          >
            <el-input
              v-model.trim="fd.deptShortName"
              class="c-form__input"
              placeholder="组织简称"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="组织标志"
            prop="deptType"
          >
            <el-radio-group
              v-model="fd.deptType"
              class="c-form__radio-group"
            >
              <el-radio
                v-for="(value,key) in deptType"
                :key="key"
                :label="value.id"
              >
                {{ value.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="统一社会信用代码"
            prop="attr.TYSHXYDM"
          >
            <el-input
              v-model="fd.attrs.TYSHXYDM"
              class="c-form__input"
              autocomplete="off"
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="所属区域"
            prop="attrs.AREA"
          >
            <select-address
              ref="SelectAddress"
              v-model="fd.attrs.AREA"
              required
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="公司地址"
            prop="attrs.GS_DZ"
          >
            <el-input
              v-model="fd.attrs.GS_DZ"
              class="c-form__input"
              autocomplete="off"
              placeholder="请输入公司地址"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="法定代表人"
            prop="attrs.FDDBR"
          >
            <el-input
              v-model="fd.attrs.FDDBR"
              class="c-form__input"
              autocomplete="off"
              placeholder="请输入法定代表人"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="联系人"
            prop="attrs.LXR"
          >
            <el-input
              v-model="fd.attrs.LXR"
              class="c-form__input"
              placeholder="请输入联系人"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="联系电话"
            prop="attrs.LXDH"
          >
            <el-input
              v-model.trim="fd.attrs.LXDH"
              class="c-form__input"
              placeholder="联系电话"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="传真"
            prop="attrs.CZ"
          >
            <el-input
              v-model.trim="fd.attrs.CZ"
              class="c-form__input"
              placeholder="传真"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="邮编"
            prop="attrs.YB"
          >
            <el-input
              v-model.trim="fd.attrs.YB"
              class="c-form__input"
              placeholder="请输入邮编"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="场地面积（m²）"
            prop="attrs.CD_MJ"
          >
            <el-input
              v-model="fd.attrs.CD_MJ"
              class="c-form__input"
              autocomplete="off"
              placeholder="请输入场地面积"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="法人证件"
            prop="frzjFiles"
          >
            <image-upload
              ref="attrs"
              v-model="fd.frzjFiles"
              multiple-file
              :file-api="$config.ctx.hmfileApi"
              show-file-list
              accept="image/*"
              :data="uploadFd"
              list-type="picture-card"
            >
              <i
                slot="default"
                class="el-icon-plus"
              />
            </image-upload>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="营业执照"
            prop="yyzzFiles"
          >
            <image-upload
              ref="attrs"
              v-model="fd.yyzzFiles"
              multiple-file
              :file-api="$config.ctx.hmfileApi"
              show-file-list
              accept="image/*"
              :data="uploadFd"
              list-type="picture-card"
            >
              <i
                slot="default"
                class="el-icon-plus"
              />
            </image-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import { deptService } from '../dept.service';

export default {
  name: 'AttrAddDeptDialog',
  props: {
    dlParams: {
      type: Object,
      required: true,
      default () {
        return {
          parentDeptCode: null,
          parentDeptName: null
        };
      }
    },
    // 扩展字段列表
    attrDeptList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        parentDeptCode: null,
        parentDeptName: null,
        deptCode: null,
        deptName: null,
        deptShortName: null,
        deptType: '0',
        deptTypeCode: '0',
        effectStartDate: null,
        effectEndDate: null,
        attrs: {
          TYSHXYDM: null,
          LXR: null,
          LXDH: null,
          CZ: null,
          YB: null,
          YYZZ: [],
          AREA: null,
          AREA_NAME: null,
          GS_DZ: null,
          FDDBR: null,
          CD_MJ: null,
          FRZJ: null
        }, // 扩展字段
        frzjFiles: [],
        yyzzFiles: []
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        deptCode: [
          this.$validUtils.required('组织代码')
        ],
        deptName: [
          this.$validUtils.required('组织名称'),
          this.$HMValidator.maxLength('组织名称', 100)
        ],
        deptShortName: [
          this.$HMValidator.maxLength('组织简称', 50)
        ],
        deptType: [
          this.$validUtils.required('组织标志')
        ],
        effectStartDate: [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'effectEndDate', ['有效期起', '有效期止'])
        ],
        effectEndDate: [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'effectStartDate', ['有效期起', '有效期止'])
        ],
        'attrs.AREA': [this.$validUtils.required('所属区域')],
        'attrs.TYSHXYDM': [
          this.$validUtils.required('统一社会信用代码'),
          this.$HMValidator.tyshxydm('统一社会信用代码')
        ],
        'attrs.CD_MJ': [
          this.$validUtils.positiveNumber('场地面积')
        ]
      },
      /* 表单校验规则 End */
      /* 文件服务器对接参数 Start */
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'type',
            value: 'fileId'
          }
        ]
      }
      /* 文件服务器对接参数 End */
    };
  },
  computed: {
    // 部门类型
    deptType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.DEPT_TYPE) {
        return enums.DEPT_TYPE;
      }
      return {};
    },
    // 获取枚举
    enums () {
      return this.$HMStoreService.getEnums();
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 处理表单保存的数据
     * @param {*}
     * @return {*}
     */
    handleFormatFd () {
      const fd = _.clone(this.fd);
      if (!fd.parentDeptCode) {
        fd.parentDeptCode = '-1';
        fd.parentDeptName = '根部门';
      }
      return fd;
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.fd.attrs.FRZJ = this.fd.frzjFiles.join(';');
      _this.fd.attrs.YYZZ = this.fd.yyzzFiles.join(';');
      _this.fd.attrs.AREA_NAME = this.$refs.SelectAddress.getAddressMc().join(' ');
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          const _fd = _this.handleFormatFd();
          deptService.save(_fd)
            .then(rsp => {
              _this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.$emit('closeDialog', rsp.data.data);
            })
            .catch(err => {
              console.error('新增机构错误!', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 初始化有效期
     * @param {*}
     * @return {*}
     */
    handleSetEffectDate () {
      const _now = new Date();
      const _nowY = _now.getFullYear();
      const _nowM = _now.getMonth() + 1;
      const _nowD = _now.getDate();
      const startDate = new Date(_nowY + '-' + _nowM + '-' + _nowD).getTime();
      const endDate = new Date('9999-12-31').getTime();

      this.fd.effectStartDate = startDate;
      this.fd.effectEndDate = endDate;
    }
  },
  created () {
    this.fd.parentDeptCode = this.dlParams.parentDeptCode;
    this.fd.parentDeptName = this.dlParams.parentDeptName;
    this.handleSetEffectDate();
  }
};
</script>
